/**
 * The ServiceGateway API
 * The ServiceGateway provides APIs to interact with the Gintel Easy Business Communications Suite (EBCS)
 *
 * OpenAPI spec version: 1.14.31-SNAPSHOT
 * Contact: frank.paaske@gintel.com
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent }                           from '@angular/common/http';
import { CustomHttpUrlEncodingCodec }                        from '../encoder';

import { Observable }                                        from 'rxjs';

import { GetCountersResponse } from '../model/getCountersResponse';
import { GetReportForServiceNumberBaselineResponse } from '../model/getReportForServiceNumberBaselineResponse';
import { GetReportForServiceNumberResponse } from '../model/getReportForServiceNumberResponse';
import { GetReportForUserBaselineResponse } from '../model/getReportForUserBaselineResponse';
import { GetReportForUserResponse } from '../model/getReportForUserResponse';

import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';
import { StatsticsServiceInterface }                            from './statstics.serviceInterface';


@Injectable()
export class StatsticsService implements StatsticsServiceInterface {

    protected basePath = 'http://localhost:8080/ServiceGateway/rest';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();

    constructor(protected httpClient: HttpClient, @Optional()@Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {
        if (basePath) {
            this.basePath = basePath;
        }
        if (configuration) {
            this.configuration = configuration;
            this.basePath = basePath || configuration.basePath || this.basePath;
        }
    }

    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    private canConsumeForm(consumes: string[]): boolean {
        const form = 'multipart/form-data';
        for (const consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }


    /**
     * 
     * 
     * @param name 
     * @param id 
     * @param organization 
     * @param login 
     * @param serviceType 
     * @param from 
     * @param to 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getCounters1(name: string, id: number, organization?: string, login?: string, serviceType?: 'Normal' | 'Inbound' | 'Outbound', from?: string, to?: string, observe?: 'body', reportProgress?: boolean): Observable<GetCountersResponse>;
    public getCounters1(name: string, id: number, organization?: string, login?: string, serviceType?: 'Normal' | 'Inbound' | 'Outbound', from?: string, to?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<GetCountersResponse>>;
    public getCounters1(name: string, id: number, organization?: string, login?: string, serviceType?: 'Normal' | 'Inbound' | 'Outbound', from?: string, to?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<GetCountersResponse>>;
    public getCounters1(name: string, id: number, organization?: string, login?: string, serviceType?: 'Normal' | 'Inbound' | 'Outbound', from?: string, to?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (name === null || name === undefined) {
            throw new Error('Required parameter name was null or undefined when calling getCounters1.');
        }

        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling getCounters1.');
        }






        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (serviceType !== undefined && serviceType !== null) {
            queryParameters = queryParameters.set('serviceType', <any>serviceType);
        }
        if (from !== undefined && from !== null) {
            queryParameters = queryParameters.set('from', <any>from);
        }
        if (to !== undefined && to !== null) {
            queryParameters = queryParameters.set('to', <any>to);
        }

        let headers = this.defaultHeaders;
        if (organization !== undefined && organization !== null) {
            headers = headers.set('organization', String(organization));
        }
        if (login !== undefined && login !== null) {
            headers = headers.set('login', String(login));
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];

        return this.httpClient.get<GetCountersResponse>(`${this.basePath}/statistics/counters/${encodeURIComponent(String(name))}/${encodeURIComponent(String(id))}`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param organization 
     * @param login 
     * @param reportType 
     * @param serviceType 
     * @param serviceNumber 
     * @param cid 
     * @param from 
     * @param to 
     * @param granularity 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getReportForServiceNumber1(organization?: string, login?: string, reportType?: 'AGENT_REPORT_TYPE' | 'QUEUE_REPORT_TYPE' | 'GEO_REPORT_TYPE' | 'LIMITED_QUEUE_REPORT_TYPE' | 'SNO_REPORT_TYPE' | 'TRAFFIC_REPORT_TYPE' | 'QUEUE_TRAFFIC_REPORT_TYPE' | 'ENTRY_REPORT_TYPE' | 'WAITING_TIME_QUEUE_REPORT_TYPE' | 'CDR_REPORT_TYPE' | 'EU_IN_REPORT_TYPE' | 'CDR_HISTORY_REPORT' | 'SNO_REPORT_SIMPLE_TYPE' | 'LIMITED_QUEUE_REPORT_TYPE_AGGREGATED', serviceType?: 'Normal' | 'Inbound' | 'Outbound', serviceNumber?: string, cid?: number, from?: string, to?: string, granularity?: 'None' | 'Month' | 'Week' | 'Day' | 'Hour' | 'Quarter' | 'Period', observe?: 'body', reportProgress?: boolean): Observable<GetReportForServiceNumberResponse>;
    public getReportForServiceNumber1(organization?: string, login?: string, reportType?: 'AGENT_REPORT_TYPE' | 'QUEUE_REPORT_TYPE' | 'GEO_REPORT_TYPE' | 'LIMITED_QUEUE_REPORT_TYPE' | 'SNO_REPORT_TYPE' | 'TRAFFIC_REPORT_TYPE' | 'QUEUE_TRAFFIC_REPORT_TYPE' | 'ENTRY_REPORT_TYPE' | 'WAITING_TIME_QUEUE_REPORT_TYPE' | 'CDR_REPORT_TYPE' | 'EU_IN_REPORT_TYPE' | 'CDR_HISTORY_REPORT' | 'SNO_REPORT_SIMPLE_TYPE' | 'LIMITED_QUEUE_REPORT_TYPE_AGGREGATED', serviceType?: 'Normal' | 'Inbound' | 'Outbound', serviceNumber?: string, cid?: number, from?: string, to?: string, granularity?: 'None' | 'Month' | 'Week' | 'Day' | 'Hour' | 'Quarter' | 'Period', observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<GetReportForServiceNumberResponse>>;
    public getReportForServiceNumber1(organization?: string, login?: string, reportType?: 'AGENT_REPORT_TYPE' | 'QUEUE_REPORT_TYPE' | 'GEO_REPORT_TYPE' | 'LIMITED_QUEUE_REPORT_TYPE' | 'SNO_REPORT_TYPE' | 'TRAFFIC_REPORT_TYPE' | 'QUEUE_TRAFFIC_REPORT_TYPE' | 'ENTRY_REPORT_TYPE' | 'WAITING_TIME_QUEUE_REPORT_TYPE' | 'CDR_REPORT_TYPE' | 'EU_IN_REPORT_TYPE' | 'CDR_HISTORY_REPORT' | 'SNO_REPORT_SIMPLE_TYPE' | 'LIMITED_QUEUE_REPORT_TYPE_AGGREGATED', serviceType?: 'Normal' | 'Inbound' | 'Outbound', serviceNumber?: string, cid?: number, from?: string, to?: string, granularity?: 'None' | 'Month' | 'Week' | 'Day' | 'Hour' | 'Quarter' | 'Period', observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<GetReportForServiceNumberResponse>>;
    public getReportForServiceNumber1(organization?: string, login?: string, reportType?: 'AGENT_REPORT_TYPE' | 'QUEUE_REPORT_TYPE' | 'GEO_REPORT_TYPE' | 'LIMITED_QUEUE_REPORT_TYPE' | 'SNO_REPORT_TYPE' | 'TRAFFIC_REPORT_TYPE' | 'QUEUE_TRAFFIC_REPORT_TYPE' | 'ENTRY_REPORT_TYPE' | 'WAITING_TIME_QUEUE_REPORT_TYPE' | 'CDR_REPORT_TYPE' | 'EU_IN_REPORT_TYPE' | 'CDR_HISTORY_REPORT' | 'SNO_REPORT_SIMPLE_TYPE' | 'LIMITED_QUEUE_REPORT_TYPE_AGGREGATED', serviceType?: 'Normal' | 'Inbound' | 'Outbound', serviceNumber?: string, cid?: number, from?: string, to?: string, granularity?: 'None' | 'Month' | 'Week' | 'Day' | 'Hour' | 'Quarter' | 'Period', observe: any = 'body', reportProgress: boolean = false ): Observable<any> {










        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (reportType !== undefined && reportType !== null) {
            queryParameters = queryParameters.set('reportType', <any>reportType);
        }
        if (serviceType !== undefined && serviceType !== null) {
            queryParameters = queryParameters.set('serviceType', <any>serviceType);
        }
        if (serviceNumber !== undefined && serviceNumber !== null) {
            queryParameters = queryParameters.set('serviceNumber', <any>serviceNumber);
        }
        if (cid !== undefined && cid !== null) {
            queryParameters = queryParameters.set('cid', <any>cid);
        }
        if (from !== undefined && from !== null) {
            queryParameters = queryParameters.set('from', <any>from);
        }
        if (to !== undefined && to !== null) {
            queryParameters = queryParameters.set('to', <any>to);
        }
        if (granularity !== undefined && granularity !== null) {
            queryParameters = queryParameters.set('granularity', <any>granularity);
        }

        let headers = this.defaultHeaders;
        if (organization !== undefined && organization !== null) {
            headers = headers.set('organization', String(organization));
        }
        if (login !== undefined && login !== null) {
            headers = headers.set('login', String(login));
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];

        return this.httpClient.get<GetReportForServiceNumberResponse>(`${this.basePath}/statistics/serviceReport`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param serviceNumber 
     * @param cid 
     * @param organization 
     * @param login 
     * @param reportType 
     * @param serviceType 
     * @param baseline 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getReportForServiceNumberBaseline1(serviceNumber: string, cid: number, organization?: string, login?: string, reportType?: 'AGENT_REPORT_TYPE' | 'QUEUE_REPORT_TYPE' | 'GEO_REPORT_TYPE' | 'LIMITED_QUEUE_REPORT_TYPE' | 'SNO_REPORT_TYPE' | 'TRAFFIC_REPORT_TYPE' | 'QUEUE_TRAFFIC_REPORT_TYPE' | 'ENTRY_REPORT_TYPE' | 'WAITING_TIME_QUEUE_REPORT_TYPE' | 'CDR_REPORT_TYPE' | 'EU_IN_REPORT_TYPE' | 'CDR_HISTORY_REPORT' | 'SNO_REPORT_SIMPLE_TYPE' | 'LIMITED_QUEUE_REPORT_TYPE_AGGREGATED', serviceType?: 'Normal' | 'Inbound' | 'Outbound', baseline?: 'BASELINE_TODAY' | 'BASELINE_THIS_WEEK' | 'BASELINE_THIS_MONTH' | 'BASELINE_THIS_YEAR', observe?: 'body', reportProgress?: boolean): Observable<GetReportForServiceNumberBaselineResponse>;
    public getReportForServiceNumberBaseline1(serviceNumber: string, cid: number, organization?: string, login?: string, reportType?: 'AGENT_REPORT_TYPE' | 'QUEUE_REPORT_TYPE' | 'GEO_REPORT_TYPE' | 'LIMITED_QUEUE_REPORT_TYPE' | 'SNO_REPORT_TYPE' | 'TRAFFIC_REPORT_TYPE' | 'QUEUE_TRAFFIC_REPORT_TYPE' | 'ENTRY_REPORT_TYPE' | 'WAITING_TIME_QUEUE_REPORT_TYPE' | 'CDR_REPORT_TYPE' | 'EU_IN_REPORT_TYPE' | 'CDR_HISTORY_REPORT' | 'SNO_REPORT_SIMPLE_TYPE' | 'LIMITED_QUEUE_REPORT_TYPE_AGGREGATED', serviceType?: 'Normal' | 'Inbound' | 'Outbound', baseline?: 'BASELINE_TODAY' | 'BASELINE_THIS_WEEK' | 'BASELINE_THIS_MONTH' | 'BASELINE_THIS_YEAR', observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<GetReportForServiceNumberBaselineResponse>>;
    public getReportForServiceNumberBaseline1(serviceNumber: string, cid: number, organization?: string, login?: string, reportType?: 'AGENT_REPORT_TYPE' | 'QUEUE_REPORT_TYPE' | 'GEO_REPORT_TYPE' | 'LIMITED_QUEUE_REPORT_TYPE' | 'SNO_REPORT_TYPE' | 'TRAFFIC_REPORT_TYPE' | 'QUEUE_TRAFFIC_REPORT_TYPE' | 'ENTRY_REPORT_TYPE' | 'WAITING_TIME_QUEUE_REPORT_TYPE' | 'CDR_REPORT_TYPE' | 'EU_IN_REPORT_TYPE' | 'CDR_HISTORY_REPORT' | 'SNO_REPORT_SIMPLE_TYPE' | 'LIMITED_QUEUE_REPORT_TYPE_AGGREGATED', serviceType?: 'Normal' | 'Inbound' | 'Outbound', baseline?: 'BASELINE_TODAY' | 'BASELINE_THIS_WEEK' | 'BASELINE_THIS_MONTH' | 'BASELINE_THIS_YEAR', observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<GetReportForServiceNumberBaselineResponse>>;
    public getReportForServiceNumberBaseline1(serviceNumber: string, cid: number, organization?: string, login?: string, reportType?: 'AGENT_REPORT_TYPE' | 'QUEUE_REPORT_TYPE' | 'GEO_REPORT_TYPE' | 'LIMITED_QUEUE_REPORT_TYPE' | 'SNO_REPORT_TYPE' | 'TRAFFIC_REPORT_TYPE' | 'QUEUE_TRAFFIC_REPORT_TYPE' | 'ENTRY_REPORT_TYPE' | 'WAITING_TIME_QUEUE_REPORT_TYPE' | 'CDR_REPORT_TYPE' | 'EU_IN_REPORT_TYPE' | 'CDR_HISTORY_REPORT' | 'SNO_REPORT_SIMPLE_TYPE' | 'LIMITED_QUEUE_REPORT_TYPE_AGGREGATED', serviceType?: 'Normal' | 'Inbound' | 'Outbound', baseline?: 'BASELINE_TODAY' | 'BASELINE_THIS_WEEK' | 'BASELINE_THIS_MONTH' | 'BASELINE_THIS_YEAR', observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (serviceNumber === null || serviceNumber === undefined) {
            throw new Error('Required parameter serviceNumber was null or undefined when calling getReportForServiceNumberBaseline1.');
        }

        if (cid === null || cid === undefined) {
            throw new Error('Required parameter cid was null or undefined when calling getReportForServiceNumberBaseline1.');
        }






        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (reportType !== undefined && reportType !== null) {
            queryParameters = queryParameters.set('reportType', <any>reportType);
        }
        if (serviceType !== undefined && serviceType !== null) {
            queryParameters = queryParameters.set('serviceType', <any>serviceType);
        }
        if (baseline !== undefined && baseline !== null) {
            queryParameters = queryParameters.set('baseline', <any>baseline);
        }

        let headers = this.defaultHeaders;
        if (organization !== undefined && organization !== null) {
            headers = headers.set('organization', String(organization));
        }
        if (login !== undefined && login !== null) {
            headers = headers.set('login', String(login));
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];

        return this.httpClient.get<GetReportForServiceNumberBaselineResponse>(`${this.basePath}/statistics/serviceReportBaseline/${encodeURIComponent(String(serviceNumber))}/${encodeURIComponent(String(cid))}`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param organization 
     * @param login 
     * @param reportType 
     * @param serviceType 
     * @param reportLogin 
     * @param from 
     * @param to 
     * @param granularity 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getReportForUser1(organization?: string, login?: string, reportType?: 'AGENT_REPORT_TYPE' | 'QUEUE_REPORT_TYPE' | 'GEO_REPORT_TYPE' | 'LIMITED_QUEUE_REPORT_TYPE' | 'SNO_REPORT_TYPE' | 'TRAFFIC_REPORT_TYPE' | 'QUEUE_TRAFFIC_REPORT_TYPE' | 'ENTRY_REPORT_TYPE' | 'WAITING_TIME_QUEUE_REPORT_TYPE' | 'CDR_REPORT_TYPE' | 'EU_IN_REPORT_TYPE' | 'CDR_HISTORY_REPORT' | 'SNO_REPORT_SIMPLE_TYPE' | 'LIMITED_QUEUE_REPORT_TYPE_AGGREGATED', serviceType?: 'Normal' | 'Inbound' | 'Outbound', reportLogin?: string, from?: string, to?: string, granularity?: 'None' | 'Month' | 'Week' | 'Day' | 'Hour' | 'Quarter' | 'Period', observe?: 'body', reportProgress?: boolean): Observable<GetReportForUserResponse>;
    public getReportForUser1(organization?: string, login?: string, reportType?: 'AGENT_REPORT_TYPE' | 'QUEUE_REPORT_TYPE' | 'GEO_REPORT_TYPE' | 'LIMITED_QUEUE_REPORT_TYPE' | 'SNO_REPORT_TYPE' | 'TRAFFIC_REPORT_TYPE' | 'QUEUE_TRAFFIC_REPORT_TYPE' | 'ENTRY_REPORT_TYPE' | 'WAITING_TIME_QUEUE_REPORT_TYPE' | 'CDR_REPORT_TYPE' | 'EU_IN_REPORT_TYPE' | 'CDR_HISTORY_REPORT' | 'SNO_REPORT_SIMPLE_TYPE' | 'LIMITED_QUEUE_REPORT_TYPE_AGGREGATED', serviceType?: 'Normal' | 'Inbound' | 'Outbound', reportLogin?: string, from?: string, to?: string, granularity?: 'None' | 'Month' | 'Week' | 'Day' | 'Hour' | 'Quarter' | 'Period', observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<GetReportForUserResponse>>;
    public getReportForUser1(organization?: string, login?: string, reportType?: 'AGENT_REPORT_TYPE' | 'QUEUE_REPORT_TYPE' | 'GEO_REPORT_TYPE' | 'LIMITED_QUEUE_REPORT_TYPE' | 'SNO_REPORT_TYPE' | 'TRAFFIC_REPORT_TYPE' | 'QUEUE_TRAFFIC_REPORT_TYPE' | 'ENTRY_REPORT_TYPE' | 'WAITING_TIME_QUEUE_REPORT_TYPE' | 'CDR_REPORT_TYPE' | 'EU_IN_REPORT_TYPE' | 'CDR_HISTORY_REPORT' | 'SNO_REPORT_SIMPLE_TYPE' | 'LIMITED_QUEUE_REPORT_TYPE_AGGREGATED', serviceType?: 'Normal' | 'Inbound' | 'Outbound', reportLogin?: string, from?: string, to?: string, granularity?: 'None' | 'Month' | 'Week' | 'Day' | 'Hour' | 'Quarter' | 'Period', observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<GetReportForUserResponse>>;
    public getReportForUser1(organization?: string, login?: string, reportType?: 'AGENT_REPORT_TYPE' | 'QUEUE_REPORT_TYPE' | 'GEO_REPORT_TYPE' | 'LIMITED_QUEUE_REPORT_TYPE' | 'SNO_REPORT_TYPE' | 'TRAFFIC_REPORT_TYPE' | 'QUEUE_TRAFFIC_REPORT_TYPE' | 'ENTRY_REPORT_TYPE' | 'WAITING_TIME_QUEUE_REPORT_TYPE' | 'CDR_REPORT_TYPE' | 'EU_IN_REPORT_TYPE' | 'CDR_HISTORY_REPORT' | 'SNO_REPORT_SIMPLE_TYPE' | 'LIMITED_QUEUE_REPORT_TYPE_AGGREGATED', serviceType?: 'Normal' | 'Inbound' | 'Outbound', reportLogin?: string, from?: string, to?: string, granularity?: 'None' | 'Month' | 'Week' | 'Day' | 'Hour' | 'Quarter' | 'Period', observe: any = 'body', reportProgress: boolean = false ): Observable<any> {









        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (reportType !== undefined && reportType !== null) {
            queryParameters = queryParameters.set('reportType', <any>reportType);
        }
        if (serviceType !== undefined && serviceType !== null) {
            queryParameters = queryParameters.set('serviceType', <any>serviceType);
        }
        if (reportLogin !== undefined && reportLogin !== null) {
            queryParameters = queryParameters.set('reportLogin', <any>reportLogin);
        }
        if (from !== undefined && from !== null) {
            queryParameters = queryParameters.set('from', <any>from);
        }
        if (to !== undefined && to !== null) {
            queryParameters = queryParameters.set('to', <any>to);
        }
        if (granularity !== undefined && granularity !== null) {
            queryParameters = queryParameters.set('granularity', <any>granularity);
        }

        let headers = this.defaultHeaders;
        if (organization !== undefined && organization !== null) {
            headers = headers.set('organization', String(organization));
        }
        if (login !== undefined && login !== null) {
            headers = headers.set('login', String(login));
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];

        return this.httpClient.get<GetReportForUserResponse>(`${this.basePath}/statistics/userReport`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param reportLogin 
     * @param organization 
     * @param login 
     * @param reportType 
     * @param serviceType 
     * @param baseline 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getReportForUserBaseline1(reportLogin: string, organization?: string, login?: string, reportType?: 'AGENT_REPORT_TYPE' | 'QUEUE_REPORT_TYPE' | 'GEO_REPORT_TYPE' | 'LIMITED_QUEUE_REPORT_TYPE' | 'SNO_REPORT_TYPE' | 'TRAFFIC_REPORT_TYPE' | 'QUEUE_TRAFFIC_REPORT_TYPE' | 'ENTRY_REPORT_TYPE' | 'WAITING_TIME_QUEUE_REPORT_TYPE' | 'CDR_REPORT_TYPE' | 'EU_IN_REPORT_TYPE' | 'CDR_HISTORY_REPORT' | 'SNO_REPORT_SIMPLE_TYPE' | 'LIMITED_QUEUE_REPORT_TYPE_AGGREGATED', serviceType?: 'Normal' | 'Inbound' | 'Outbound', baseline?: 'BASELINE_TODAY' | 'BASELINE_THIS_WEEK' | 'BASELINE_THIS_MONTH' | 'BASELINE_THIS_YEAR', observe?: 'body', reportProgress?: boolean): Observable<GetReportForUserBaselineResponse>;
    public getReportForUserBaseline1(reportLogin: string, organization?: string, login?: string, reportType?: 'AGENT_REPORT_TYPE' | 'QUEUE_REPORT_TYPE' | 'GEO_REPORT_TYPE' | 'LIMITED_QUEUE_REPORT_TYPE' | 'SNO_REPORT_TYPE' | 'TRAFFIC_REPORT_TYPE' | 'QUEUE_TRAFFIC_REPORT_TYPE' | 'ENTRY_REPORT_TYPE' | 'WAITING_TIME_QUEUE_REPORT_TYPE' | 'CDR_REPORT_TYPE' | 'EU_IN_REPORT_TYPE' | 'CDR_HISTORY_REPORT' | 'SNO_REPORT_SIMPLE_TYPE' | 'LIMITED_QUEUE_REPORT_TYPE_AGGREGATED', serviceType?: 'Normal' | 'Inbound' | 'Outbound', baseline?: 'BASELINE_TODAY' | 'BASELINE_THIS_WEEK' | 'BASELINE_THIS_MONTH' | 'BASELINE_THIS_YEAR', observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<GetReportForUserBaselineResponse>>;
    public getReportForUserBaseline1(reportLogin: string, organization?: string, login?: string, reportType?: 'AGENT_REPORT_TYPE' | 'QUEUE_REPORT_TYPE' | 'GEO_REPORT_TYPE' | 'LIMITED_QUEUE_REPORT_TYPE' | 'SNO_REPORT_TYPE' | 'TRAFFIC_REPORT_TYPE' | 'QUEUE_TRAFFIC_REPORT_TYPE' | 'ENTRY_REPORT_TYPE' | 'WAITING_TIME_QUEUE_REPORT_TYPE' | 'CDR_REPORT_TYPE' | 'EU_IN_REPORT_TYPE' | 'CDR_HISTORY_REPORT' | 'SNO_REPORT_SIMPLE_TYPE' | 'LIMITED_QUEUE_REPORT_TYPE_AGGREGATED', serviceType?: 'Normal' | 'Inbound' | 'Outbound', baseline?: 'BASELINE_TODAY' | 'BASELINE_THIS_WEEK' | 'BASELINE_THIS_MONTH' | 'BASELINE_THIS_YEAR', observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<GetReportForUserBaselineResponse>>;
    public getReportForUserBaseline1(reportLogin: string, organization?: string, login?: string, reportType?: 'AGENT_REPORT_TYPE' | 'QUEUE_REPORT_TYPE' | 'GEO_REPORT_TYPE' | 'LIMITED_QUEUE_REPORT_TYPE' | 'SNO_REPORT_TYPE' | 'TRAFFIC_REPORT_TYPE' | 'QUEUE_TRAFFIC_REPORT_TYPE' | 'ENTRY_REPORT_TYPE' | 'WAITING_TIME_QUEUE_REPORT_TYPE' | 'CDR_REPORT_TYPE' | 'EU_IN_REPORT_TYPE' | 'CDR_HISTORY_REPORT' | 'SNO_REPORT_SIMPLE_TYPE' | 'LIMITED_QUEUE_REPORT_TYPE_AGGREGATED', serviceType?: 'Normal' | 'Inbound' | 'Outbound', baseline?: 'BASELINE_TODAY' | 'BASELINE_THIS_WEEK' | 'BASELINE_THIS_MONTH' | 'BASELINE_THIS_YEAR', observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (reportLogin === null || reportLogin === undefined) {
            throw new Error('Required parameter reportLogin was null or undefined when calling getReportForUserBaseline1.');
        }






        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (reportType !== undefined && reportType !== null) {
            queryParameters = queryParameters.set('reportType', <any>reportType);
        }
        if (serviceType !== undefined && serviceType !== null) {
            queryParameters = queryParameters.set('serviceType', <any>serviceType);
        }
        if (baseline !== undefined && baseline !== null) {
            queryParameters = queryParameters.set('baseline', <any>baseline);
        }

        let headers = this.defaultHeaders;
        if (organization !== undefined && organization !== null) {
            headers = headers.set('organization', String(organization));
        }
        if (login !== undefined && login !== null) {
            headers = headers.set('login', String(login));
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];

        return this.httpClient.get<GetReportForUserBaselineResponse>(`${this.basePath}/statistics/userReportBaseline/${encodeURIComponent(String(reportLogin))}`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
